import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IAccountSummary, IAccountSummaryLabel, IUser } from '../../core/models/index';
import { CustomerService } from '../../core/services/customer.service';
import { LanguageTranslationService } from '../../core/services/language-translation.service';

@Component({
  selector: 'app-account-summary',
  templateUrl: './account-summary.component.html',
  styleUrls: ['./account-summary.component.scss']
})
export class AccountSummaryComponent implements OnInit {
  id: string ='./KNAPB2.xlsm';
  u: SafeResourceUrl;
  public accountSummaryLbl: IAccountSummaryLabel;
  constructor(private customerService: CustomerService,
    private formBuilder: FormBuilder, private sanitizer: DomSanitizer, private languageTranslationService: LanguageTranslationService) { }

  public get readUserObject(): IUser {
    return JSON.parse(localStorage.getItem('user')) as IUser;
  }
  public customerName: string;
  public billingAddress: string;
  public accountSummary: IAccountSummary = null;

  //trustSrcUrl = function (data) {
  //  return this.sanitizer.bypassSecurityTrustResourceUrl(data);
  //}


  ngOnInit(): void {
    this.u = this.sanitizer.bypassSecurityTrustResourceUrl(this.id); 
    this.initializeNgOnInit();
  }

  initializeNgOnInit() {
    this.loadLanguageTranslationData();
    this.initializeFormFields();
    this.customerName = this.readUserObject.customerName;
    this.billingAddress = this.readUserObject.addressLine1 ? this.readUserObject.addressLine1 : "" + " " + this.readUserObject.city ? this.readUserObject.city : "" + "," + " " + this.readUserObject.state ? this.readUserObject.state : "" + " " + this.readUserObject.zipCode ? this.readUserObject.zipCode:"";
    
    this.getAccountSummary(this.readUserObject.customerNumber);

  }
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "amountDueLbl" },
      { controlName: "billingAddressLbl" },
      { controlName: "creditLmtLbl" },
      { controlName: "dateLastPaidLbl" },
      { controlName: "dofInvoiceLbl" },
      { controlName: "lastInvoiceDateLbl" },
      { controlName: "openOrderAmtLbl" },
      { controlName: "overCreditLmtLbl" },
      { controlName: "paymentTermsLbl" },
      { controlName: "totalExposureLbl" },
    ];
    const componentName = "accountSummary";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.accountSummaryLbl = response[response.length - 1];
    }    
  }

  //#endregion
  initializeFormFields() {
    this.accountSummary = {
      amountDue: "",
      creditLimit: "",
      dateLastPaid: "",
      dateOfFirstInvoice: "",
      lastInvoiceDate: "",
      openOrderAmount: "",
      overCreditLimit: "",
      paymentTerms: "",
      totalExposure: "",
    }

  }

  public accountSummaryPage = {
    amountDueLbl: "Amount Due",
    billingAddressLbl: "Billing Address ",
    totalExposureLbl: "Total Exposure",
    overCreditLmtLbl: "Over Credit Limit",
    lastInvoiceDateLbl: "Last Invoice Date",
    paymentTermsLbl: "Payment Terms",
    openOrderAmtLbl: "Open Order Amount",
    creditLmtLbl: "Credit Limit",
    dofInvoiceLbl: "Date Of First Invoice",
    dateLastPaidLbl: "Date Last Paid",
  };


  public getAccountSummary(customerNumber: string) {
    this.customerService.getAccountSummary(customerNumber).subscribe((response: any) => {
      if (response) {

        this.accountSummary = response;

      }

    })
  };

}
